import { Container, Sprite, type Texture } from "pixi.js";
import { SpriteText, SpriteTextFitMode } from "@slot/presentation";
import type { SpriteFontDefinition } from "@slot/presentation";

/** The `cannonProjectile` prefab: the `cannon_round` plate (151×149) and the digits. */
const BULLET = { plate: { width: 151, height: 149 }, text: { y: -3.9, box: { width: 97, height: 79 } } } as const;

/**
 * CannonBulletView — the per-bullet visual contract (the `cannonProjectile` prefab). Owns the
 * bullet's OWN appearance: its plate and multiplier label. `CannonView` orchestrates (spawn,
 * position, recycle) and talks to the bullet only through this.
 */
export class CannonBulletView extends Container {
  public readonly spriteText: SpriteText | null;
  public readonly plate: Sprite | null;

  public constructor(input: { plateTexture: Texture | null; font: SpriteFontDefinition | null }) {
    super({ label: "cannonProjectile" });
    this.plate = input.plateTexture ? new Sprite({ texture: input.plateTexture, anchor: 0.5, label: "bg" }) : null;
    if (this.plate) {
      this.plate.width = BULLET.plate.width;
      this.plate.height = BULLET.plate.height;
      this.addChild(this.plate);
    }
    this.spriteText = input.font
      ? new SpriteText({ font: input.font, maxCharacters: 24, glyphScale: 1, fitMode: SpriteTextFitMode.Both, boxWidth: BULLET.text.box.width, boxHeight: BULLET.text.box.height, label: "SpriteText" })
      : null;
    if (this.spriteText) {
      this.spriteText.position.set(0, BULLET.text.y);
      this.addChild(this.spriteText);
    }
  }

  /** Set the bullet's multiplier label (already formatted, e.g. "x3"). */
  public setMultiplier(text: string): void {
    this.spriteText?.setText(text);
  }
}
